export default {
  velt: {
    openPanel: 'Buksan ang panel ng mga komento',
    closePanel: 'Isara ang panel ng mga komento',
    panel: 'Panel ng mga komento',
    tabs: 'Mga tab ng panel ng mga komento',
    comments: 'Mga komento',
    settings: 'Mga Setting at Pahintulot',
    dragOrTapComment: 'I-drag para magdagdag ng komento, o i-tap para tingnan ang mga komento',
    assignComment: 'Italaga ang komento',
    markAsUnread: 'Markahan bilang hindi pa nabasa',
    markAsRead: 'Markahan bilang nabasa',
    unsubscribe: 'Mag-unsubscribe',
    subscribe: 'Mag-subscribe',
    deleteThread: 'Tanggalin ang thread',
    editComment: 'I-edit ang komento',
    emptyPlaceholder: 'Magbigay ng feedback, magtanong, o mag-iwan ng tala para sa mga miyembro ng iyong team',
    searchPlaceholder: 'Maghanap ng mga Komento',
    commentPlaceholder: 'Magkomento sa {page}',
    replyPlaceholder: 'Tumugon....',
    filterPages: 'Mga pahina',
    filterAuthor: 'May-akda',
    filterTagged: 'Naka-tag',
    statusOpen: 'Bukas',
    statusResolved: 'Nalutas',
    anonymous: 'Anonymous',
    settingsPanel: {
      title: 'Sino ang maaaring magkomento?',
      everyoneLabel: 'Lahat',
      restrictedLabel: 'Mga inimbitahang collaborator lang',
      emailsLabel: 'Mga email',
      emailsPlaceholder: 'Magdagdag ng email at pindutin ang enter',
    },
  },
}
